const baseURL = `${process.env.REACT_APP_BASE_URL}/api`;

// API to Get platform guidelines Data
const getPlatformData = async (slug: string): Promise<any> => {
  slug=slug=="HTML/CSS"?"HTML-CSS":slug;
  const url = `${baseURL}/platforms/${slug}`;

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    return Promise.reject(error); // ✅ hamesha actual error reject karo
  }
};

export { getPlatformData };
